import { ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { accountsLinks } from '@/backend/routes';
import { AdditionAccountHeaderContent } from '@/ui/features/accounts';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { AccountDetails, AccountDetailsProps } from '@juvare/contact-management/ui/features/accounts/components/AccountDetails';
import { OccupationInformation, PersonSubtitle } from '@juvare/credentialing/ui/features/person-credentials';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const RmsAccountDetailsComponent = ({
    account,
    onClose,
    isScrolledToTop,
    accountPermissions,
    menuItems,
}: Pick<AccountDetailsProps, 'account' | 'onClose' | 'isScrolledToTop' | 'accountPermissions' | 'menuItems'>) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const navigationContext = React.useContext(NavigationContext);

    const handleNavigateToAccountPage = () => {
        navigationContext.navigate(() => {
            navigate(`${accountsLinks.root}/${account.id}`, { state: { back: true } });
        });
    };

    const accountData = account.data as ExtendedAccountData;

    const detailsConfig: AccountDetailsProps = {
        reloadOktaStatus: () => {},
        isScrolledToTop,
        account,
        accountPermissions,
        completionBarTitle: t('common.profileCompletion'),
        subTitle: (
            <PersonSubtitle
                tribeId={accountData.address?.tribeId}
                county={accountData.address?.county}
                residenceType={accountData.address?.residenceType}
            />
        ),
        additionalContent: <OccupationInformation personData={accountData} />,
        onViewProfile: handleNavigateToAccountPage,
        additionalHeaderContent: <AdditionAccountHeaderContent accountId={account.id} account={accountData} cardStyle='slideout' />,
        onClose,
        menuItems,
    };
    return <AccountDetails {...detailsConfig} />;
};
